<template>
  <li :class="[isFolder ? 'folder' : 'file']">
    <a v-if="model.type !== 'delimiter'" class="menu-label"
        :class="{'open': open}"
        :href="model.href">
      {{ model.title }}
      <span @click.prevent.stop="toggle" v-if="isFolder" class="cd-accordion-menu--arrow cd-accordion-menu--arrow_default" :class="{'cd-accordion-menu--arrow_open' : open}">
      </span>
<!--      <span v-if="isFolder">{{ isFolder ? model.child.length : '' }}</span>-->
    </a>
    <div v-if="model.type === 'delimiter'" class="delimiter"></div>
    <ul v-show="open" v-if="isFolder" :class="{'open': open}">
      <MenuItem
          v-for="(model, index) in model.child"
          :key="index"
          :model="model">
      </MenuItem>
    </ul>
  </li>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    model: Object
  },
  data: function () {
    return {
      open: false
    };
  },
  computed: {
    isFolder: function () {
      return this.model.child && this.model.child.length;
    }
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.open = !this.open;
      }
    }
  }
}
</script>

<style scoped>

</style>